import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NotificationsState {
  /** Whether the arrival sound plays. Persisted per browser. */
  soundEnabled: boolean;
}

interface NotificationsActions {
  setSoundEnabled: (enabled: boolean) => void;
  toggleSound: () => void;
}

type NotificationsStore = NotificationsState & NotificationsActions;

const initialState: NotificationsState = {
  soundEnabled: true,
};

export const useNotificationsStore = create<NotificationsStore>()(
  persist(
    (set) => ({
      ...initialState,

      setSoundEnabled: (soundEnabled) => set({ soundEnabled }),
      toggleSound: () =>
        set((state) => ({ soundEnabled: !state.soundEnabled })),
    }),
    {
      name: "notifications-store",
      partialize: (state) => ({ soundEnabled: state.soundEnabled }),
      version: 1,
    }
  )
);
